import React, { useState, useEffect } from 'react';
import axios from 'axios';

const CMAList = () => {
  const [cma, setCMA] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCMA();
  }, []);

  const fetchCMA = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cma`);
      setCMA(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setError('Failed to fetch data. Please try again later.');
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/cma/${id}`);
      fetchCMA();
    } catch (error) {
      console.error('Error deleting data:', error);
      setError('Failed to delete entry. Please try again.');
    }
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">CMA Ships Data</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300 rounded-md">
              <thead>
                <tr className="bg-gray-200 border-b border-gray-300">
                  <th className="py-2 px-4 text-left">ID</th>
                  <th className="py-2 px-4 text-left">Crew On Board</th>
                  <th className="py-2 px-4 text-left">New Principals</th>
                  <th className="py-2 px-4 text-left">Income per COB</th>
                  <th className="py-2 px-4 text-left">Cost Per C.O.B</th>
                  <th className="py-2 px-4 text-left">Date</th>
                  <th className="py-2 px-4 text-left">Actions</th>
                </tr>
              </thead>
              <tbody>
                {cma.map((item) => (
                  <tr key={item.id} className="border-b border-gray-300">
                    <td className="py-2 px-4">{item.id}</td>
                    <td className="py-2 px-4">{item.crew_on_board}</td>
                    <td className="py-2 px-4">{item.new_principals}</td>
                    <td className="py-2 px-4">{item.income}</td>
                    <td className="py-2 px-4">{item.cost}</td>
                    <td className="py-2 px-4">{item.date}</td>
                    <td className="py-2 px-4">
                      <button
                        onClick={() => handleDelete(item.id)}
                        className="text-white-500 hover:text-gray-700"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CMAList;
